// Protected surface: review docs/protected-surfaces/admin-surfaces.md before changing shared admin access rules.
export const isAdminUser = (candidate) => {
  if (!candidate || typeof candidate !== 'object') return false;
  const role = String(candidate.role || '').toLowerCase();
  return role === 'admin' || candidate.is_staff === true;
};

export const resolveAppEntryPath = (candidate) => (isAdminUser(candidate) ? '/app/admin' : '/app');
